/**
 * Display-only currency formatter with thousand separators.
 * e.g. 27641 -> "$27,641.00", 694305.5 -> "$694,305.50"
 * Does not mutate underlying numeric values.
 */
export const formatPrice = (num: number | undefined | null): string => {
  if (num === undefined || num === null || Number.isNaN(Number(num))) {
    return 'unavailable'
  }

  const value = Number(num)
  const withCommas = Math.abs(value).toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })

  const sign = value < 0 ? '-' : ''
  return `${sign}$${withCommas}`
}
